import styled from "@emotion/styled"

const StyledMedia = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .open-media-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .item-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 12px;
  }

  .item .MuiCard-root {
    height: 100%;
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    box-shadow: 0 10px 20px rgba(15, 23, 42, 0.06);
  }

  .item .MuiCardContent-root {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .resource-type {
    margin: 0;
    font-size: 20px;
    line-height: 1.25;
    color: var(--cms-text-primary);
    font-weight: 800;
  }

  .count-line {
    color: var(--cms-text-secondary);
    font-weight: 600;
    font-size: 13px;
  }

  .count-label {
    font-size: 26px;
    font-weight: 800;
    color: #7c3aed;
  }

  .resource-desc {
    margin-top: 4px;
    color: var(--cms-text-primary);
    line-height: 1.45;
    font-size: 13px;
  }

  .find-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-height: 34px;
    padding: 4px 10px;
  }

  .page-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }
`

export { StyledMedia }
